!(function(t) {
  t.add("plugin", "fullscreen", {
    translations: { en: { fullscreen: "Fullscreen" } },
    init: function(t) {
      (this.app = t),
        (this.opts = t.opts),
        (this.lang = t.lang),
        (this.$win = t.$win),
        (this.$doc = t.$doc),
        (this.$body = t.$body),
        (this.editor = t.editor),
        (this.toolbar = t.toolbar),
        (this.container = t.container),
        (this.selection = t.selection),
        (this.isOpen = !1);
    },
    start: function() {
      var e = {
        title: this.lang.get("fullscreen"),
        api: "plugin.fullscreen.toggle"
      };
      this.toolbar
        .addButton("fullscreen", e)
        .setIcon('<i class="re-icon-expand"></i>'),
        (this.isTarget = this.opts.toolbarFixedTarget !== document),
        (this.$target = this.isTarget
          ? t.dom(this.opts.toolbarFixedTarget)
          : this.$body),
        this.opts.fullscreen && this.toggle();
    },
    toggle: function() {
      return this.isOpen ? this.close() : this.open();
    },
    open: function() {
      this._createPlacemarker(), this.selection.save();
      var e = this.container.getElement(),
        s = this.editor.getElement(),
        i = this.isTarget ? t.dom("body, html") : this.$target;
      this.opts.toolbarExternal && this._buildInternalToolbar(),
        this.$target.prepend(e),
        this.$target.addClass("redactor-body-fullscreen"),
        e.addClass("redactor-box-fullscreen"),
        this.isTarget && e.addClass("redactor-box-fullscreen-target"),
        i.css("overflow", "hidden"),
        this.opts.maxHeight && s.css("max-height", ""),
        this.opts.minHeight && s.css("min-height", ""),
        this._resize(),
        this.$win.on(
          "resize.redactor-plugin-fullscreen",
          this._resize.bind(this)
        ),
        this.$doc.scrollTop(0),
        this.toolbar
          .getButton("fullscreen")
          .setIcon('<i class="re-icon-retract"></i>'),
        this.selection.restore(),
        (this.isOpen = !0),
        (this.opts.zindex = 1051);
    },
    close: function() {
      (this.isOpen = !1), (this.opts.zindex = !1), this.selection.save();
      var e = this.container.getElement(),
        s = this.editor.getElement(),
        i = t.dom("body, html");
      this.opts.toolbarExternal && this._buildExternalToolbar(),
        this.$target.removeClass("redactor-body-fullscreen"),
        this.$win.off("resize.redactor-plugin-fullscreen"),
        i.css("overflow", ""),
        e.removeClass("redactor-box-fullscreen redactor-box-fullscreen-target"),
        s.css("height", "auto"),
        this.opts.minHeight && s.css("minHeight", this.opts.minHeight),
        this.opts.maxHeight && s.css("maxHeight", this.opts.maxHeight),
        this.toolbar
          .getButton("fullscreen")
          .setIcon('<i class="re-icon-expand"></i>'),
        this._removePlacemarker(e),
        this.selection.restore();
    },
    _resize: function() {
      var t = this.editor.getElement(),
        e = this.$win.height();
      t.height(e);
    },
    _buildInternalToolbar: function() {
      var t = this.toolbar.getWrapper(),
        e = this.toolbar.getElement();
      t.addClass("redactor-toolbar-wrapper"),
        t.append(e),
        e.removeClass("redactor-toolbar-external"),
        $container.prepend(t);
    },
    _buildExternalToolbar: function() {
      var e = this.toolbar.getWrapper(),
        s = this.toolbar.getElement();
      (this.$external = t.dom(this.opts.toolbarExternal)),
        s.addClass("redactor-toolbar-external"),
        this.$external.append(s),
        e.remove();
    },
    _createPlacemarker: function() {
      var e = this.container.getElement();
      (this.$placemarker = t.dom("<span />")), e.after(this.$placemarker);
    },
    _removePlacemarker: function(t) {
      this.$placemarker.before(t), this.$placemarker.remove();
    }
  });
})(Redactor);
